// Components
const ModalOrderDetails = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-order-details"*/ '@/app/views/main-view/dog-orders/containers/modals/modal-order-details/modal-order-details.vue');
const ModalDisapproveCancellationRequest = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-disapprove-cancellation-request"*/ '@/app/views/main-view/dog-orders/containers/modals/modal-disapprove-cancellation-request/modal-disapprove-cancellation-request.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins';

// Constants
import { STATUS_CODES, TRANSACTION_STATUS } from '@/app/constants/constants';

// Services
import OrdersAPI from '@/app/services/main/orders/orders-service.js';
import PaymentAPI from '@/app/services/main/payment/payment-service.js';

export default {
	name: 'PendingOrdersContainer',
	components: {
		ModalOrderDetails,
		ModalDisapproveCancellationRequest
	},
	mixins: [
		tableMixins,
		productMixins,
		toastMessageMixins
	],
	data() {
		const statusList = [
			{
				id: 'For delivery',
				name: 'For delivery'
			},
			{
				id: 'For cancellation',
				name: 'For cancellation'
			},
			{
				id: 'Cancelled',
				name: 'Cancelled'
			},
			{
				id: 'Out for delivery',
				name: 'Out for delivery'
			},
			{
				id: 'Delivered',
				name: 'Delivered'
			}
		];

		return {
			isAPILoading: false,
			isCreatingTracker: false,
			modifyMode: '',
			selectedOrder: {},
			// table
			theads: [
				{ name: 'Order Number', searchLabel: 'f_id', sortLabel: 'createdAt', isDesc: false, hasSearch: true, style: null},
				{ name: 'User', searchLabel: 'f_fullName', sortLabel: 'fullName', isDesc: false, hasSearch: true, style: null},
				{ name: 'Address', searchLabel: 'f_shippingAddress', sortLabel: 'shippingAddress', isDesc: false, hasSearch: true, style: null},
				{ name: 'Price', searchLabel: 'f_totalPrice', sortLabel: 'totalPrice', isDesc: false, hasSearch: true, style: 'min-width: 150px'},
				{ name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasSearchableDropdown: false, optionList: statusList, style: 'min-width: 225px'},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'width: 170px'}
			],
			// sorting
			desc: true
		}
	},
	created() {
		this.getTableContent();
	},
	methods: {
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page;
			this.getOrdersList({ page, limit, sortBy, desc });
		},
		getOrdersList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				const {
					f_id,
					f_fullName,
					f_shippingAddress,
					f_totalPrice,
				} = this.columnsFilter;

				if (f_id) {
					queryParams['f_id'] = f_id;
				}

				if (f_fullName) {
					queryParams['f_fullName'] = f_fullName;
				}

				if (f_shippingAddress) {
					queryParams['f_shippingAddress'] = f_shippingAddress;
				}

				if (f_totalPrice) {
					queryParams['f_totalPrice'] = f_totalPrice;
				}

			}
			
			this.isAPILoading = true;

			OrdersAPI.getPendingDogPurchaseOrders(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
					} else {
						this.showAPIErrorToast('Unable to get order list.', res);
					}
					this.isAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		},
		showModifyTrackingModal(order, mode) {
			this.selectedOrder = order;
			this.modifyMode = mode;

			setTimeout(() => {
				this.$refs.modalModifyTracking.openModal();
			}, 50);
		},
		showOrderDetailsModal(orderId) {
			this.$router.push(`${orderId}/view`);
		},
		showModalDisapprove(orderDetails) {
			this.$refs.modalDisapprove.openModal(orderDetails);
		},
		getClassByStatus(status) {
			const {
				REQUEST_CANCELLATION,
				CANCELLED,
				REFUNDED,
				DELIVERED
			} = TRANSACTION_STATUS;

			switch (status) {
				case DELIVERED:
					return 'text-success';

				case REQUEST_CANCELLATION:
					return 'text-warning';

				case CANCELLED:
				case REFUNDED:
					return 'text-danger';

				default:
					return 'text-primary';
			}
		},
		handleRefreshTableContent() {
			this.getTableContent(false);
		},
		deleteDogOrder(order){
			const { SUCCESS_DELETE } = this.toastMessages.order();
			
			this.$swal({
				title: 'Delete Pending Dog Order',
				text: `Are you sure you want to delete this pending dog order of ${order.recipientName}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
				.then(result => {
					if (result.value) {
						this.isAPILoading = true;
						OrdersAPI.deletePendingDogPurchaseOrders(order.id)
							.then(res => {
								this.isAPILoading = false;

								this.handleRefreshTableContent();
								
								this.showCustomSuccessToast(SUCCESS_DELETE);
							})
							.catch(() => {
								this.showGenericErrorToast();
								this.isAPILoading = false;
							});
					}
				});
		},
		reProcessDogOrder(order){
			PaymentAPI.putPaymentStatus(order.id)
				.then(res => {
					this.isAPILoading = false;
						if(res.status === 400 || res.status === 500 || res.status === 404){
							this.showCustomErrorToast(null, res.data.errors[0].message);
						}else{
							if(res.data.status === 'DECLINED'){
								this.showCustomErrorToast(null,res.data.message);
							}else{
								this.showCustomSuccessToast(`The order #${order.id} has been successfully updated!`);
							}
						}
						this.handleRefreshTableContent();
					})
					.catch(() => {
						this.showGenericErrorToast();
						this.isAPILoading = false;
					});
		}
	}
}